import { render, staticRenderFns } from "./cpt-image.vue?vue&type=template&id=b79cd396&scoped=true"
import script from "./cpt-image.vue?vue&type=script&lang=js"
export * from "./cpt-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79cd396",
  null
  
)

export default component.exports